<template>
    <section v-if="creditContact.id" class="bs-validation">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">
                            {{ localizationStore.translate('credit.contact.form.title') }}
                        </h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6 col-12">
                                <div class="form-group">
                                    <label class="form-label" for="creditor_name">
                                        {{ localizationStore.translate('credit.contact.form.title.name') }}
                                    </label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        :value="creditContact.creditor_name"
                                        readonly
                                    />
                                </div>
                            </div>
                            <div class="col-md-6 col-12">
                                <div class="form-group">
                                    <label class="form-label" for="creditor_fax_number">
                                        {{ localizationStore.translate('credit.contact.form.title.faxnumber') }}
                                    </label>
                                    <input
                                        type="text"
                                        id="creditor_fax_number"
                                        name="fax_number"
                                        class="form-control"
                                        :value="creditContact.fax_number"
                                        readonly
                                    />
                                </div>
                            </div>
                            <div class="col-md-6 col-12">
                                <div class="form-group">
                                    <label class="d-block" for="address">
                                        {{ localizationStore.translate('credit.contact.form.title.address') }}
                                    </label>
                                    <textarea
                                        class="form-control"
                                        rows="3"
                                        readonly
                                    >{{ creditContact.address }}</textarea>
                                </div>
                            </div>
                            <div class="col-md-6 col-12">
                                <div class="form-group">
                                    <label class="d-block" for="address_line">
                                        {{ localizationStore.translate('credit.contact.form.title.address_line') }}
                                    </label>
                                    <textarea
                                        class="form-control"
                                        rows="3"
                                        readonly
                                    >{{ creditContact.address_line }}</textarea>
                                </div>
                            </div>
                            <div class="col-md-3 col-12">
                                <div class="form-group">
                                    <label class="form-label" for="city">
                                        {{ localizationStore.translate('credit.contact.form.title.city') }}
                                    </label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        :value="creditContact.city"
                                        readonly
                                    />
                                </div>
                            </div>
                            <div class="col-md-3 col-12">
                                <div class="form-group">
                                    <label class="form-label" for="state">
                                        {{ localizationStore.translate('credit.contact.form.title.state') }}
                                    </label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        :value="creditContact.state"
                                        readonly
                                    />
                                </div>
                            </div>
                            <div class="col-md-3 col-12">
                                <div class="form-group">
                                    <label class="form-label" for="zipcode">
                                        {{ localizationStore.translate('credit.contact.form.title.zipcode') }}
                                    </label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        :value="creditContact.zipcode"
                                        readonly
                                    />
                                </div>
                            </div>
                            <div class="col-md-3 col-12">
                                <div class="form-group">
                                    <label class="form-label" for="phone">
                                        {{ localizationStore.translate('credit.contact.form.title.phone') }}
                                    </label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        :value="creditContact.phone"
                                        readonly
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <button
                                    v-if="this.$route.params && this.$route.params.client"
                                    class="btn btn-primary"
                                    @click="creditContactStore.type = 1"   
                                >
                                    {{ localizationStore.translate('credit.contact.form.back.button.text') }}
                                </button>
                                <router-link
                                    v-else
                                    :to="{ name: 'credit-contact-index' }"
                                    class="btn btn-primary"
                                >
                                    {{ localizationStore.translate('credit.contact.form.back.button.text') }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { ref, reactive } from 'vue'
    import { useCreditContactStore } from '../../stores/CreditContactStore.js'
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    export default {
        setup()
        {
            return {
                creditContact : reactive({}),
                creditContactStore: useCreditContactStore(),
                localizationStore: useLocalizationStore(),
            }
        },
        mounted() {
            let params = {}, url = this.$route.href;
            if (this.$route.params && this.$route.params.client) {                
                const route = this.$router.resolve(
                    {
                        name: 'credit-contact-preview',
                        params: {
                            credit_contact: this.creditContactStore.credit_contact_id
                        }
                    }
                );
                url = route.href;
            }
            let $this = this;
            axios.get(
                url
            ).then(function(response) {
                if(response.data.error == true) {
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                Object.assign($this.creditContact, response.data.data.credit_contact)
                return;
            }).catch(function(error) {
                setTimeout(() => {
                    toastr.error(error.response.data.response_msg, 'Error!');
                }, 2000)
            });
        }
    }
</script>
